var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr } from '@ember-data/model';
export let SurveyKey = /*#__PURE__*/function (SurveyKey) {
  SurveyKey["CHANNEL_LISTINGS_FEEDBACK"] = "CHANNEL_LISTINGS_FEEDBACK";
  SurveyKey["CHANNELS_OVERVIEW_FEEDBACK"] = "CHANNELS_OVERVIEW_FEEDBACK";
  return SurveyKey;
}({});

// MetaData is supposed to be union type of all feedback survey meta_data columns.
/* | SomeOtherMetaData */
let SurveyResponse = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('number'), _dec5 = attr('string'), _dec6 = attr('json-or-value'), _dec7 = attr('date'), _class = class SurveyResponse extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "surveyKey", _descriptor, this);
    _initializerDefineProperty(this, "merchantId", _descriptor2, this);
    _initializerDefineProperty(this, "locale", _descriptor3, this);
    _initializerDefineProperty(this, "csatScore", _descriptor4, this);
    _initializerDefineProperty(this, "freeFormResponse", _descriptor5, this);
    _initializerDefineProperty(this, "metaData", _descriptor6, this);
    _initializerDefineProperty(this, "createdAt", _descriptor7, this);
  }
  get channels() {
    if (!this.isChannelsFeedbackSurveyResponse(this)) {
      throw new Error('This survey response does not contain meta data on active channels');
    }
    return this.metaData.channels;
  }
  isChannelsFeedbackSurveyResponse(surveyResponse) {
    return surveyResponse.surveyKey === SurveyKey.CHANNEL_LISTINGS_FEEDBACK || surveyResponse.surveyKey === SurveyKey.CHANNELS_OVERVIEW_FEEDBACK;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "surveyKey", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "merchantId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "locale", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "csatScore", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "freeFormResponse", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "metaData", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { SurveyResponse as default };